'use client'

import dynamic from 'next/dynamic'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import React, { useEffect, useRef } from 'react'
import { useInfiniteQuery } from '@tanstack/react-query'
import { getSettingList } from '@/lib/api'
import parse from 'html-react-parser'
import ToietMoiEngagementRing from './ToietMoiEngagementRing'

const SettingItem = dynamic(() => import('./SettingItem'))

const SettingListClient = (props: any) => {
  const router = useRouter()
  const selectedProductId = useRef<any>(null)
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const currentPath = `${pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
    queryKey: ['settingList', currentPath],
    initialPageParam: 0,
    queryFn: async ({ pageParam = 0 }) => {
      const res = await getSettingList({
        ...props.payload,
        page_no: pageParam
      })
      return {
        products: res?.result?.data ?? [],
        totalRecords: pageParam === 0 ? (res?.result?.total_records ?? 0) : undefined,
        offers: pageParam === 0 ? res.result?.category?.offer_banner[0] : null
      }
    },
    getNextPageParam: (lastPage, allPages) => {
      const totalFetched = allPages.reduce((sum, page) => sum + page?.products.length, 0)
      const totalRecords = allPages[0]?.totalRecords ?? 0
      return totalFetched < totalRecords ? allPages.length : undefined
    }
  })
  useEffect(() => {
    if (!props.isDetailsPage) {
      const handleScroll = () => {
        sessionStorage.setItem('settingListScrollY', String(window.scrollY))
      }

      window.addEventListener('scroll', handleScroll)
      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    }
  }, [props.isDetailsPage])
  useEffect(() => {
    if (!props.isDetailsPage) {
      const y = sessionStorage.getItem('settingListScrollY')
      if (y !== null) {
        requestAnimationFrame(() => {
          window.scrollTo({
            top: parseInt(y),
            left: 0,
            behavior: 'instant'
          })
          // window.scrollTo(0, parseInt(y))
          sessionStorage.removeItem('settingListScrollY')
        })
      }
    }
  }, [props.isDetailsPage])

  const Navigate = (link: any) => {
    router.push(link)
  }

  const setSelectedProduct = (productId: any) => {
    if (productId !== undefined) {
      selectedProductId.current = productId
    }
  }

  useEffect(() => {
    const headers = document.querySelectorAll('.accordion-header')

    headers.forEach((header) => {
      const clickHandler = () => {
        const item = header.closest('.accordion-item')
        if (!item) return

        const isActive = item.classList.contains('active')

        // remove active from all
        document
          .querySelectorAll('.accordion-item.active')
          .forEach((i) => i.classList.remove('active'))

        // if it was NOT active, activate it
        if (!isActive) {
          item.classList.add('active')
        }
      }

      header.addEventListener('click', clickHandler)

      // cleanup (important in Next.js)
      return () => {
        header.removeEventListener('click', clickHandler)
      }
    })
  }, [])

  const getofferbaner = (img: string | Blob | undefined, slug: any, item: any, index: number) => {
    return (
      <>
        <SettingItem
          setSelectedProduct={setSelectedProduct}
          key={Math.random()}
          index={index}
          item={item}
          category={props.category}
        ></SettingItem>
        <div className="col-sm-6 col-md-6 product-listing-repeat">
          <div className="product-banner-box">
            <span
              className="product-banner-link"
              onClick={(e) => Navigate(slug)}
            >
              <div className="product-banner-title">Shop This Ring</div>
              <img
                src={img}
                alt="products"
              />
            </span>
          </div>
        </div>
      </>
    )
  }
  const getProductList = () => {
    return data?.pages.map((group, i) => (
      <React.Fragment key={i}>
        {group.products?.map((item: any, index: any) =>
          index + 1 === parseInt(data?.pages[0]?.offers?.after_products_1) ? (
            getofferbaner(
              data?.pages[0]?.offers?.offer_image_1,
              data?.pages[0]?.offers?.offer_banner_slug_1,
              item,
              index
            )
          ) : index + 1 === parseInt(data?.pages[0]?.offers?.after_products_2) ? (
            getofferbaner(
              data?.pages[0]?.offers?.offer_image_2,
              data?.pages[0]?.offers?.offer_banner_slug_2,
              item,
              index
            )
          ) : (
            <SettingItem
              setSelectedProduct={setSelectedProduct}
              key={index}
              index={index}
              item={item}
              category={props.category}
            ></SettingItem>
          )
        )}
      </React.Fragment>
    ))
  }
  const handleNvigate = (url: string) => {
    router.push(url)
  }
  return (
    <>
      <div className="container-fluid">
        <div className="product-result">
          <div className="product-result-count">
            Showing {data?.pages[0]?.totalRecords || 0} Results
          </div>
        </div>
        <div className="product-listing">
          <div className="row product-listing-row">
            {data?.pages[0]?.totalRecords > 0 ? (
              getProductList()
            ) : (
              <p className="text-center">We found no results that match your criteria.</p>
            )}
          </div>
          {hasNextPage ? (
            <center>
              <button
                id="btnLoadMore"
                className="btn btn-custom mb-4"
                onClick={() => {
                  fetchNextPage()
                }}
              >
                {isFetchingNextPage ? <>Loading....</> : <>Load More</>}
              </button>
            </center>
          ) : null}
          {props.category.footer_title &&
            props.category.footer_title !== null &&
            props.category.footer_title !== 'null' && (
              <div className="category-bottom-content">
                <h2 className="main-title-heading">{props.category?.footer_title}</h2>
                <div>{parse(props.category?.footer_description)}</div>
              </div>
            )}
          {props.category?.footer_cms_content && (
            <div className="listing-bottom-details">
              {parse(props.category?.footer_cms_content)}
            </div>
          )}

          {props.category?.faqs !== undefined && props.category?.faqs?.length > 0 && (
            <div className="category-bottom-faq">
              <h3 className="main-title-heading">
                Frequently <br></br>Asked Questions
              </h3>
              <div className="main-sub-content">
                Trusted answers for your precious diamond jewellery
              </div>
              <div
                className="accordion"
                id="accordionExample"
              >
                {props.category.faqs.map((x: any, index: number) => {
                  const headingId = `heading${index}`
                  const collapseId = `collapse${index}`
                  return (
                    <div
                      className="accordion-item"
                      key={index}
                    >
                      <h4
                        className="accordion-header"
                        id={headingId}
                      >
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#${collapseId}`}
                          aria-expanded="false"
                          aria-controls={collapseId}
                        >
                          {x.label}
                        </button>
                      </h4>
                      <div
                        id={collapseId}
                        className="accordion-collapse collapse"
                        aria-labelledby={headingId}
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">{parse(x.value)}</div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
          {props.category?.explore_more?.length > 0 && (
            <div className="category-bottom-content explore-related-content">
              <h3 className="main-title-heading">Explore Related Pages</h3>
              <div className="category-bottom-link">
                {props.category?.explore_more.map((x: any, index: any) => (
                  <div
                    className="category-bottom-link-list"
                    key={index}
                  >
                    <button onClick={() => handleNvigate(x.value)}>{x.label}</button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default SettingListClient
